import { Navigate } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

/**
 * Ruta /mi-empresa: redirige al detalle de la empresa del usuario.
 *
 * Resuelve el id de la empresa desde:
 *  - `effectiveEmpresaId` del AuthContext (cubre admin_empresa y admin
 *    impersonando)
 *
 * Si no hay empresa asociada (admin_general/operador sin impersonacion),
 * muestra una advertencia.
 */
export default function MiEmpresa() {
  const { loading, profile, effectiveEmpresaId } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!profile) {
    return <Navigate to="/auth/login" replace />;
  }

  if (effectiveEmpresaId) {
    return <Navigate to={`/empresas/${effectiveEmpresaId}`} replace />;
  }

  return (
    <Alert severity="warning">
      Tu cuenta no esta asociada a ninguna empresa. Contacta al administrador del sistema.
    </Alert>
  );
}
